import { LoadableAfterPaint } from '@confluence/loadable';

export const TinyEditPageDataLoaderLoader = LoadableAfterPaint({
	loader: () =>
		import(/* webpackChunkName: "loadable-EditPageDataLoader" */ './TinyEditPageDataLoader'),
});
